"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeTimetableInput = exports.getValidTimetableRulesByDay = exports.isDateAllowedOnTimetable = exports.getCurrentTimetableRules = exports.formatStartAndEndTime = exports.isTimetableEmpty = exports.filterTimetable = exports.getTimezonedDate = void 0;
var lodash_1 = require("lodash");
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var main_api_1 = require("../main-api");
/*
Example:

```json
[
  {
    "days": [0,1],
    "start": "18:00",
    "end": "20:00",
    "type": "ALLOWANCE",
    "state": "CONTROLLED"
  }
]
```
*/
function getTimezonedDate(date, timezone) {
    return moment_timezone_1.default.tz(date, timezone);
}
exports.getTimezonedDate = getTimezonedDate;
function filterTimetable(timezonedDate, timetable, timezone) {
    if (Array.isArray(timetable)) {
        return timetable.filter(function (rule) {
            if (rule.startDate &&
                timezonedDate.isBefore(getTimezonedDate(new Date(rule.startDate), timezone))) {
                return false; // Rule has not started yet
            }
            if (rule.endDate &&
                timezonedDate.isAfter(getTimezonedDate(new Date(rule.endDate), timezone))) {
                return false; // Rule has already ended
            }
            return true;
        });
    }
    return timetable;
}
exports.filterTimetable = filterTimetable;
function isTimetableEmpty(timetable) {
    return !timetable || !Array.isArray(timetable) || timetable.length === 0;
}
exports.isTimetableEmpty = isTimetableEmpty;
function formatStartAndEndTime(timezonedDate, rule) {
    var _a = rule.start.split(':'), startHours = _a[0], startMinutes = _a[1];
    var _b = rule.end.split(':'), endHours = _b[0], endMinutes = _b[1];
    var today = timezonedDate.clone().hours(0).minutes(0);
    var startTime = today.clone().hours(+startHours).minutes(+startMinutes);
    var endTime = today.clone().hours(+endHours).minutes(+endMinutes);
    if (endTime.isSameOrBefore(startTime)) {
        endTime = endTime.add(1, 'day'); // Account for 12am - 12am schedule
    }
    return { startTime: startTime, endTime: endTime };
}
exports.formatStartAndEndTime = formatStartAndEndTime;
function getCurrentTimetableRules(timezonedDate, timetable) {
    var currentTimetableRules = [];
    var weekDay = timezonedDate.isoWeekday();
    for (var _i = 0, timetable_1 = timetable; _i < timetable_1.length; _i++) {
        var rule = timetable_1[_i];
        if (rule.days.findIndex(function (day) { return weekDay === day; }) < 0) {
            continue;
        }
        var _a = formatStartAndEndTime(timezonedDate, rule), startTime = _a.startTime, endTime = _a.endTime;
        if (!timezonedDate.isSameOrAfter(startTime) || !timezonedDate.isBefore(endTime)) {
            continue;
        }
        currentTimetableRules.push(rule);
    }
    return currentTimetableRules;
}
exports.getCurrentTimetableRules = getCurrentTimetableRules;
function isDateAllowedOnTimetable(date, timetable, timezone) {
    if (date === void 0) { date = new Date(); }
    var timezonedDate = getTimezonedDate(date, timezone);
    var filteredTimetable = filterTimetable(timezonedDate, timetable, timezone);
    if (!filteredTimetable || isTimetableEmpty(filteredTimetable)) {
        return true;
    }
    var currentTimetableRules = getCurrentTimetableRules(timezonedDate, filteredTimetable);
    // RESTRICTION rules will take priority over all ALLOWANCE rules
    return Boolean(currentTimetableRules.length &&
        currentTimetableRules.every(function (r) { return r.type === main_api_1.TimetableRuleType.ALLOWANCE; }));
}
exports.isDateAllowedOnTimetable = isDateAllowedOnTimetable;
function getValidTimetableRulesByDay(timezonedDate, timetable) {
    var validTimetableRules = [];
    var weekDay = timezonedDate.isoWeekday();
    for (var _i = 0, timetable_2 = timetable; _i < timetable_2.length; _i++) {
        var rule = timetable_2[_i];
        if (rule.days.findIndex(function (day) { return weekDay === day; }) < 0) {
            continue;
        }
        if (rule.type === main_api_1.TimetableRuleType.RESTRICTION) {
            return []; // RESTRICTION takes priority over all ALLOWANCE rules
        }
        if (rule.type === main_api_1.TimetableRuleType.ALLOWANCE) {
            validTimetableRules.push(rule);
        }
    }
    return validTimetableRules;
}
exports.getValidTimetableRulesByDay = getValidTimetableRulesByDay;
function sanitizeTimetableInput(timetable) {
    // Avoid storing null values for "state", "startDate", and "endDate" in UserRole schedules
    return Array.isArray(timetable) && timetable.length
        ? timetable.map(function (r) { return (0, lodash_1.pickBy)(r, function (v) { return v !== null && v !== undefined; }); })
        : undefined;
}
exports.sanitizeTimetableInput = sanitizeTimetableInput;
//# sourceMappingURL=index.js.map